import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  PTRAB_SESSION_REPOSITORY,
  PtrabSessionRepository
} from '@app/domain/repositories/ptrab/session/session.repository.contract';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';

import { PtrabSessionUseCases } from './session.use-cases.contract';

@Injectable({
  providedIn: 'root'
})
export class PtrabSessionUseCasesImpl implements PtrabSessionUseCases {
  #ptrabSessionRepository: PtrabSessionRepository = inject(PTRAB_SESSION_REPOSITORY);

  getSessionStatus(): Observable<HttpErrorResponse | void> {
    return this.#ptrabSessionRepository.getSessionStatus();
  }

  ptrabLogin(password: string, sms_hash?: string): Observable<MSafeAny> {
    return this.#ptrabSessionRepository.ptrabLogin(password, sms_hash);
  }

  ptrabLogout(): Observable<MSafeAny> {
    return this.#ptrabSessionRepository.ptrabLogout();
  }
}
